/** One notification for successful booking writes across all page/search instances. */
export const BOOKINGS_CHANGED_EVENT = 'bookings-changed';
export type BookingsChangedDetail = { bookingId?: string; enteredInIlocaId?: string };

export function notifyBookingsChanged(detail: BookingsChangedDetail = {}): void {
  window.dispatchEvent(new CustomEvent<BookingsChangedDetail>(BOOKINGS_CHANGED_EVENT, { detail }));
}
